// POST /auth/verify/resend — mints a new verification token for the given email.
// NOTE: as of 2026-08-30 this endpoint is deferred on BE ("deferred" in
// registration.service.ts:109). The function is implemented correctly; calls
// will 404 until BE ships the route. Wire the Resend button to this function
// and accept that behaviour until the endpoint lands.
const GATEWAY_URL =
  (import.meta.env.VITE_GATEWAY_URL as string | undefined) ??
  (import.meta.env.VITE_GRAPHQL_URL as string | undefined)?.replace(/\/graphql\/?$/, '') ??
  'http://localhost:4000'

const RESEND_URL = `${GATEWAY_URL}/auth/verify/resend`

export type ResendOutcome =
  | { ok: true }
  | { ok: false; reason: 'rate_limited' | 'network_error' }

export async function resendVerifyEmail(email: string): Promise<ResendOutcome> {
  try {
    const res = await fetch(RESEND_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
    if (res.ok) return { ok: true }
    if (res.status === 429) return { ok: false, reason: 'rate_limited' }
    return { ok: false, reason: 'network_error' }
  } catch {
    return { ok: false, reason: 'network_error' }
  }
}
